module.exports = __webpack_public_path__ + "static/media/chor_kiu_lee.abedcf78.jpg";